export const siteSettings = {
  name: "Block Gains Portal",
  link: "https://blockgainsportal.live",
  email: "support@blockgainsportal.live",
  appLink: "https://app.blockgainsportal.live",
};
